<div class="dialog-container">
  <div class="dialog-header">
    <div class="user-edit-icon">
      <img src="assets/images/health/icons/dtopico/Group 15 (1).svg" class="add-icon" alt="User Icon" />
    </div>
    <div class="header-text">
        <h2 class="addmed">{{ dialogMode === 'add' ? 'Add Medication' : 'Edit Medication' }}</h2>
      </div>
    <button mat-icon-button (click)="onCancel()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>
   <div class="dialog-content">
    <form [formGroup]="medForm" class="dialog-form">
    <!-- Row 1: medCondition & medicationName -->
    <div class="form-row">
      
      <mat-form-field appearance="outline" class="w-100">
            <mat-label>Medical Condition</mat-label>
            <input
                matInput
                required
                formControlName="medCondition"
                [matAutocomplete]="auto"
                placeholder="e.g., Hypertension"
            />
            <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let condition of filteredConditions" [value]="condition.title">
                {{ condition.title}}
                </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="getError('medCondition') as err">{{ err }}</mat-error>
            </mat-form-field>


      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Medication Name </mat-label>
        <input matInput required formControlName="medicationName" placeholder="e.g., Metformin" />
        <mat-error *ngIf="getError('medicationName') as err">{{ err }}</mat-error>
      </mat-form-field>
    </div>

    <!-- Row 2: strength & unit -->
    <div class="form-row">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Strength</mat-label>
        <input matInput required type="number" formControlName="strength" min=0 max="10000000000" placeholder="e.g., 500" />
        <mat-error *ngIf="getError('strength') as err">{{ err }}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Unit </mat-label>
        <mat-select  required formControlName="unit">
          <mat-option *ngFor="let unit of medUnits" [value]="unit">{{ unit }}</mat-option>
        </mat-select>
        <mat-error *ngIf="getError('unit') as err">{{ err }}</mat-error>
      </mat-form-field>                 
    </div>

    <!-- Row 3: Start Date & End Date -->
    <div class="form-row">
      <mat-form-field appearance="outline" class="half-width">
        <mat-label>Start Date </mat-label>
        <input readonly matInput [max]="today" [matDatepicker]="picker1" formControlName="startDate" (focus)="picker1.open()" (click)="picker1.open()" />
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
        <mat-error *ngIf="getError('startDate') as err">{{ err }}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="half-width">
        <mat-label>End Date</mat-label>
        <input readonly matInput [min]="tomorrow" [matDatepicker]="picker2" formControlName="endDate" (focus)="picker2.open()" (click)="picker2.open()" />
        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
        <mat-error *ngIf="getError('endDate') as err">{{ err }}</mat-error>
      </mat-form-field>
    </div>

    <!-- Row 4: frequency & numberOfTimes -->
    <div class="form-row">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Frequency </mat-label>
        <mat-select required formControlName="frequency">
          <mat-option value="everyDay">Every Day</mat-option>
          <mat-option value="asNeeded">As Needed</mat-option>
        </mat-select>
        <mat-error *ngIf="getError('frequency') as err">{{ err }}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100" *ngIf="medForm.get('frequency')?.value === 'everyDay'">
        <mat-label>Dosage </mat-label>
        <input matInput type="number" formControlName="numberOfTimes" min="1" max="24" />
        <mat-error *ngIf="getError('numberOfTimes') as err">{{ err }}</mat-error>
      </mat-form-field>
    </div>
    <div class="time-frequency-container" *ngIf="medForm.get('frequency')?.value === 'everyDay' && medForm.get('numberOfTimes')?.value >=1">
      <div class="time-frequency" *ngFor="let tf of time_freq; let i = index"  >
        <mat-form-field appearance="outline" class="time-field">
          <mat-label>Time {{ i + 1 }}</mat-label>
            <div class="input-with-icon">
              <img src="assets/images/health/icons/Frame 1000004270.svg" class="clckicon" alt="User Icon" />
              <input type="time" #time matInput [value]="get_time(tf.time)" (input)="time_edit(time.value, i, medForm.get('numberOfTimes')?.value)">
          </div>
        </mat-form-field>
      </div>
    </div>
  

    <!-- Row 5: Qty and Comment -->
    <div class="form-row">

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Comment</mat-label>
        <input matInput formControlName="comment" placeholder="Optional notes..." />
      </mat-form-field>
    </div>

    
  </form>

   </div>
   <!-- Action Buttons -->
    <div class="dialog-actions">
      <button mat-stroked-button color="primary" (click)="onCancel()">Cancel</button>
      <button mat-flat-button color="primary" (click)="onSave()">Save</button>
    </div>
  
</div>
